import type { SVGProps } from 'react';

export function CactusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 22a1 1 0 0 1-.117-1.993L7 20h1a1 1 0 0 0 1-1v-4c0-.552-.455-.988-.99-1.124A4 4 0 0 1 5.005 10.2L5 10V9a1 1 0 0 1 1.993-.117L7 9v1a2 2 0 0 0 1.85 1.995.145.145 0 0 0 .15-.145V5a3 3 0 0 1 5.995-.176L15 5v9c0 .552.474 1.02.959.756a2 2 0 0 0 1.036-1.606L17 13V8a1 1 0 0 1 1.993-.117L19 8v5a4 4 0 0 1-3.8 3.995.205.205 0 0 0-.2.205V19a1 1 0 0 0 1 1h1a1 1 0 0 1 .117 1.993L17 22z" />
    </svg>
  );
}
